import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUrlPath } from '../selectors';
import { push, go, goForward } from 'connected-react-router';
import BeforeExitDialog from '@sunbit-dev/ui/src/components/card-apply/components/beforeExitDialog/BeforeExitDialog';
import { EXIT_WITHOUT_PROMPT } from '../constants/urls';
// UGLY HACK!
// when pressing back we are going back to previous history state, then the dialog asking if to stay or leave.
// if the user wants to stay we need to go 1 step forward and it triggers 'popstate' again.
// I tryied to use removeEventListener but it didn't worked.
// using react.useState for ignorePopstate fails due to stale-closure.
let ignorePopstate = false;

const landingPageHistoryIndex = window.history.length;

const onBeforeOnloadFunc = () => 'If you exit the application your information will not be saved.';
const pageHasDummyHistoryState = {} as { [string: string]: boolean };
const exitWithoutPrompt = (urlPath: string) => EXIT_WITHOUT_PROMPT.indexOf(urlPath) !== -1;

const BeforeExitDialogContainer = () => {
  const dispatch = useDispatch();
  const [showCustomBeforeOnloadDialog, setShowCustomBeforeOnloadDialog] = React.useState(false);
  const urlPath = useSelector(selectUrlPath);

  const pushHistoryState = React.useCallback(() => {
    if (!pageHasDummyHistoryState[urlPath]) {
      window.removeEventListener('click', pushHistoryState);
      dispatch(push(urlPath));
    }
    pageHasDummyHistoryState[urlPath] = true;
  }, [urlPath, dispatch]);

  const goBackToReferrer = React.useCallback(() => {
    const pagesCountToGoBack = -1 * (window.history.length - landingPageHistoryIndex);
    dispatch(go(pagesCountToGoBack));
  }, [dispatch]);

  const showDialog = React.useCallback(() => {
    if (ignorePopstate) {
      ignorePopstate = false;
      return;
    }

    if (exitWithoutPrompt(urlPath)) {
      goBackToReferrer();
      return;
    }

    setShowCustomBeforeOnloadDialog(true);
  }, [urlPath, goBackToReferrer]);

  React.useEffect(() => {
    window.onpopstate = showDialog;
  }, [showDialog]);

  React.useEffect(() => {
    window.onbeforeunload = exitWithoutPrompt(urlPath) ? null : onBeforeOnloadFunc;

    if (landingPageHistoryIndex === window.history.length) {
      // browsers back button skips history.push which made before any user interaction
      window.addEventListener('click', pushHistoryState);
    } else {
      pushHistoryState();
    }
  }, [pushHistoryState, urlPath]);
  const handleContinueApplication = () => {
    setShowCustomBeforeOnloadDialog(false);
    ignorePopstate = true;
    dispatch(goForward());
  };

  const actionList = [
    {
      label: 'Continue Application',
      onClick: handleContinueApplication,
    },
    {
      label: 'Exit Application',
      onClick: () => {
        window.onbeforeunload = null;
        goBackToReferrer();
      },
    },
  ];

  return (
    <>
      {showCustomBeforeOnloadDialog && (
        <BeforeExitDialog onCloseAction={handleContinueApplication} {...{ actionList }} />
      )}
    </>
  );
};

export default BeforeExitDialogContainer;
